"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.dateTime = exports.deviceType = exports.evaluateAndFlatten = exports.evaluateEventInput = exports.isObjectEmpty = exports.isFunction = exports.isNumber = exports.isArray = exports.isObject = exports.isString = void 0;
var merge_1 = __importDefault(require("lodash/merge"));
function isString(s) {
    return Object.prototype.toString.call(s) === "[object String]";
}
exports.isString = isString;
function isObject(s) {
    return Object.prototype.toString.call(s) === "[object Object]";
}
exports.isObject = isObject;
function isArray(s) {
    return Object.prototype.toString.call(s) === "[object Array]";
}
exports.isArray = isArray;
function isNumber(s) {
    return Object.prototype.toString.call(s) === "[object Number]";
}
exports.isNumber = isNumber;
function isFunction(s) {
    return typeof s === "function";
}
exports.isFunction = isFunction;
function isPromise(s) {
    return s instanceof Promise;
}
function isObjectEmpty(obj) {
    for (var prop in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, prop)) {
            return false;
        }
    }
    return true;
}
exports.isObjectEmpty = isObjectEmpty;
/**
 * @recursive
 * @param eventInput
 */
function evaluateEventInput(eventInput) {
    return __awaiter(this, void 0, void 0, function () {
        var eventKeys_1, evaluatedEventKeys;
        return __generator(this, function (_a) {
            if (isPromise(eventInput)) {
                return [2 /*return*/, eventInput.then(function (r) { return evaluateEventInput(r); })];
            }
            if (isArray(eventInput)) {
                return [2 /*return*/, Promise.all(eventInput.map(evaluateEventInput))];
            }
            if (isFunction(eventInput)) {
                return [2 /*return*/, evaluateEventInput(Promise.resolve(eventInput()))];
            }
            if (isObject(eventInput)) {
                eventKeys_1 = Object.getOwnPropertyNames(eventInput);
                evaluatedEventKeys = eventKeys_1.reduce(function (acc, key) {
                    var eventInputProperty = eventInput[key];
                    if (isObject(eventInputProperty) || isFunction(eventInputProperty) || isPromise(eventInputProperty)) {
                        return acc.concat(evaluateEventInput(eventInputProperty));
                    }
                    return acc.concat([eventInputProperty]);
                }, []);
                return [2 /*return*/, Promise.all(evaluatedEventKeys).then(function (resolvedEventKeys) {
                        return resolvedEventKeys.reduce(function (evaluatedEventInput, resolvedEventKey, index) {
                            var _a;
                            return (0, merge_1.default)(evaluatedEventInput, (_a = {}, _a[eventKeys_1[index]] = resolvedEventKey, _a));
                        }, {});
                    })];
            }
            return [2 /*return*/, Promise.resolve(eventInput)];
        });
    });
}
exports.evaluateEventInput = evaluateEventInput;
function evaluateAndFlatten(builder) {
    if (isArray(builder)) {
        return Promise.all(builder.map(function (b) { return evaluateEventInput(b); })).then(function (results) {
            return merge_1.default.apply(void 0, __spreadArray([{}], results.filter(isObject), false));
        });
    }
    return evaluateEventInput(builder);
}
exports.evaluateAndFlatten = evaluateAndFlatten;
/**
 * Function for getting device type taken from the old SDK. It performs as well
 * as one could expect from the size. It could be replaced with 'ua-parser-js'
 * at the cost of 11kb minimized.
 *
 * @param {string} userAgent
 *
 * @returns {string} the device type the user is using
 */
function deviceType(userAgent) {
    var knownDevices = {
        mobile: [
            /iPhone;/,
            /iPod;/,
            /iPod touch;/,
            /^HTC/,
            /Fennec/,
            /IEMobile/,
            /BB10;/,
            /BlackBerry/,
            /SymbianOS.*AppleWebKit/,
            /^Mozilla.*Mobile.*Firefox/,
            /^Mozilla.*Chrome.*Mobile/,
            /Opera Mobi/,
            /Android.*Mobile/,
            /Android.*Mini/,
            /Symbian/,
            /^SonyEricsson/,
            /^Nokia/,
            /^SAMSUNG/,
            /^LG/,
        ],
        tablet: [/iPad/, /Android/],
    };
    /**
     * Hermes' apps (Shared app-platform for media) return "Hermes"&"_app_" as part of the user-agent
     * Example UA: `Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_6)
     * AppleWebKit/605.1.15 (KHTML, like Gecko) iOS AP Hermes/64.0.0 _app_`
     * @returns {boolean} Returns true if the user is inside the app.
     */
    function isHermesApp() {
        return userAgent.search(/Hermes.*_app_/) !== -1;
    }
    function isDeviceIn(devicesList) {
        for (var i = 0; i < devicesList.length; i += 1) {
            if (devicesList[i].test(userAgent)) {
                return true;
            }
        }
        return false;
    }
    if (userAgent) {
        if (isDeviceIn(knownDevices.mobile)) {
            return 'mobile';
        }
        if (isDeviceIn(knownDevices.tablet)) {
            return "tablet";
        }
        if (isHermesApp()) {
            // If not a detected device but inside app it's most likely a tablet masking itself as desktop
            return 'tablet';
        }
    }
    return 'desktop';
}
exports.deviceType = deviceType;
function dateTime() {
    return new Date().toISOString();
}
exports.dateTime = dateTime;
